import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { FinanciacionPropiaModel } from './financiacion-propia.model';
import { PartnersModel } from '../../user/partnersequity/partners/partners.model';
import { map, Observable } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { PartnersService } from '../../user/partnersequity/partners/partners.service';
import { AccountMovementsViewModel } from '../../accounting/models/accounting-movement.model';
import { AccountingMovementsImportComponent } from '../../accounting/movements/import/accounting-movements-import.component';
import { FinanciacionPropiaService } from './financiacion-propia.service';
import { BankAccountService } from '../bancos/bankaccount.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { consts } from '../../../consts';
import { SharedService } from '../../../shared/services/shared.service';
import { FinanciacionPropiaDialogImportAccount } from './financiacion-propia-dialog-importAccount.component';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-financiacion-propia-form',
    templateUrl: './financiacion-propia-form.component.html',
    styleUrls: ['./financiacion-propia.component.css'],
    standalone: false
})
export class FinanciacionPropiaFormComponent implements OnInit {

  @Input() financiacionPropia: FinanciacionPropiaModel;
  @Output() onSave = new EventEmitter<any>();

  public loading = false;
  public ready = false;

  public selectAccountList: any[] = [
    { id: '5133', name: 'Otras deudas a corto plazo con empresas del grupo - 5133' },
    { id: '5134', name: 'Otras deudas a corto plazo con empresas asociadas - 5134' },
    { id: '5135', name: 'Otras deudas a corto plazo con otras partes vinculadas - 5135' },
    { id: '1633', name: 'Otras deudas a largo plazo empresas del grupo - 1633' },
    { id: '1634', name: 'Otras deudas a largo plazo empresas asociadas - 1634' },
    { id: '1635', name: 'Otras deudas a largo plazo con otras partes vinculadas - 1635' },
  ];

  public get cuentaContableOptions(): Option[] {
    return this.selectAccountList.map(item => ({ label: item.name, value: item.id }));
  }

  public partnersList: PartnersModel[] = [];
  public partnersControl = new UntypedFormControl();
  public partnersfiltered: Observable<PartnersModel[]>;

  //AccountMovementes Import data
  flagImport = false;
  movement: AccountMovementsViewModel;
  type: string;
  saved: boolean = false;
  //------------------------------

  public bankAccounts: BankAccountModel[] = [];

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private partnersService: PartnersService,
    private financiacionPropiaService: FinanciacionPropiaService,
    @Optional() public dialogRef: MatDialogRef<AccountingMovementsImportComponent>,
    private bankAccountService: BankAccountService,
    private sharedService: SharedService,
    public dialog: MatDialog
  ) { }

  public ngOnInit(): void {
    this.ready = false;

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
      });

    if (this.data !== null) {
      this.flagImport = true;
    }

    if (this.flagImport) {
      this.movement = this.data.movement;
      this.type = this.data.type;
      this.movement.type = this.type;
      this.financiacionPropia.manualMovement = this.movement;
      this.financiacionPropia.descripcion = this.movement.reference;

      //Corto plazo
      if (this.movement.accountNumber.startsWith("5133") ||
        this.movement.accountNumber.startsWith("5134") ||
        this.movement.accountNumber.startsWith("5135")) {
        this.financiacionPropia.duracion = 1;
        this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
          this.financiacionPropia.accountingModelsLargoPlazoNumber = response;
          this.financiacionPropia.manualMovement.accountNumber = response;
        })
      }

      //Largo plazo
      if (this.movement.accountNumber.startsWith("1633") ||
        this.movement.accountNumber.startsWith("1634") ||
        this.movement.accountNumber.startsWith("1635")) {
        this.financiacionPropia.duracion = 2;
        this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
          this.financiacionPropia.accountingModelsCortoPlazoNumber = response;
        })
      }

    }

    this.partnersService.getList()
      .then(response => {
        this.partnersList = response;
        this.ready = true;
      })
      .catch(err => {
        this.ready = true;
      });

    this.partnersControl = new UntypedFormControl();
    this.partnersfiltered = this.partnersControl.valueChanges
      .pipe(
        map(partner => partner && typeof partner === 'object' ? partner.nameOrBusinessName : partner),
        map(name => this._filter(name))
      );
  }

  private _filter(val: string): PartnersModel[] {
    for (const partner of this.partnersList) {
      if (partner.nameOrBusinessName == val) {
        this.financiacionPropia.partnersName = partner.nameOrBusinessName;
      }
    }

    return val ? this.partnersList.filter(s => s.nameOrBusinessName.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.partnersList;
  }

  public save(): void {
    this.loading = true;
    let noError = true;

    if (this.financiacionPropia.cuentaContableACrear == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("Es necesario seleccionar una de las opciones del campo 'Cuenta'");
    }

    if (this.financiacionPropia.importeInicial == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Importe inicial' es requerido");
    }

    if (this.financiacionPropia.importePendiente == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Importe pendiente' es requerido");
    }

    if (this.financiacionPropia.comisionApertura == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Comisión apertura' es requerido");
    }

    if (this.financiacionPropia.fechaConstitucion == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'fecha de constitución' es requerido");
    }

    if (this.financiacionPropia.plazo == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Plazo' es requerido");
    }

    if (this.financiacionPropia.fechaFinalizacion == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'fecha de finalizacion' es requerido");
    }

    if (this.financiacionPropia.tipoInteres == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Tipo de Intereses' es requerido");
    }

    if (this.financiacionPropia.carencia == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Carencia' es requerido");
    }

    if (this.financiacionPropia.tipoLiquidaciones == null || this.financiacionPropia.tipoLiquidaciones === 0) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Tipos de liquidaciones' es requerido");
    }

    if (this.financiacionPropia.bankAccountsUid == null || this.financiacionPropia.bankAccountsUid === consts.EMPTY_GUID) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Cuenta de adeudo' es requerido");
    }

    this.setDefaultsValues();

    if (noError) {
      if (this.flagImport) {
        this.saveData(this.financiacionPropia);
      } else {
        this.onSave.emit(this.financiacionPropia);
        this.loading = false;
      }
    }
  }

  public saveData(financiacionPropia: FinanciacionPropiaModel): void {
    this.financiacionPropiaService.add(financiacionPropia)
      .then(response => {
        this.saved = true;
        this.closeDialog();
      },
        error => {
          //Si venimos de importar, y ya existe la financiación, preguntamos si queremos actualizar
          //la financiación ya existente
          if (error.error['message'].includes("ya se encuentra registrada") && this.flagImport) {
            this.dialog.open(FinanciacionPropiaDialogImportAccount, {
              width: '20%',
              //height: '40%',
              data: {
                dataImport: financiacionPropia,
              }
            }).afterClosed().subscribe(result => this.closeDialog())
          } else {
            this.displayInfo(error.error['message']);
          }
        })
  }

  public closeDialog() {
    this.dialogRef.close(this.saved);
  }

  public setDefaultsValues(): void {
    // Valores por defecto en los campos que no sean requeridos
  }

  public setTipoDeLiquidacionesOptions(value: number) {
    this.financiacionPropia.tipoLiquidaciones = value;
  }

  public setPartnerIdentifier(selectedId: number) {
    this.financiacionPropia.partnersId = selectedId;
  }

  public duracionChangeValue(corto_largo_plazo_id: number) {

    this.selectAccountList = [];

    this.financiacionPropia.accountingModelsCortoPlazoNumber = null;
    this.financiacionPropia.accountingModelsLargoPlazoNumber = null;
    this.financiacionPropia.cuentaContableACrear = null;


    // Corto plazo
    if (corto_largo_plazo_id === 1) {

      this.selectAccountList = [
        { id: '5133', name: 'Otras deudas a corto plazo con empresas del grupo - 5133' },
        { id: '5134', name: 'Otras deudas a corto plazo con empresas asociadas - 5134' },
        { id: '5135', name: 'Otras deudas a corto plazo con otras partes vinculadas - 5135' },
      ];

    }

    // Largo plazo
    if (corto_largo_plazo_id === 2) {

      this.selectAccountList = [
        { id: '1633', name: 'Otras deudas a largo plazo empresas del grupo - 1633' },
        { id: '1634', name: 'Otras deudas a largo plazo empresas asociadas - 1634' },
        { id: '1635', name: 'Otras deudas a largo plazo con otras partes vinculadas - 1635' },
      ];

    }
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public trackByIndex(i: number) { return i; }

}
